import * as actions from '../actions/articleForm';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function postNewArticle(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_NEW_ARTICLE)
        .map(action => ({
            url: BASE_URL + 'api/Articles/News',
            category: 'postNewArticle',
            method: 'POST',
            type: 'application/json',
            send: action.payload,
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http post requests, it updates the redux store with the posted new article
    let httpResponse$ = sources.HTTP
        .select('postNewArticle')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostNewArticle(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };

}

export function failedPostNewArticle(sources) {
    let httpResponse$ = sources.HTTP
        .select('postNewArticle')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >= 400 )
        .map(response => actions.failedToPostNewArticle(JSON.parse(response.response.text).message));

    return {
        ACTION: httpResponse$
    }
}